import { IStyle } from '@fluentui/react';
import { Button, buttonStylesPrimary, IButtonProps, IH2OTheme, useClassNames, useTheme } from '@h2oai/ui-kit';
import { ReactNode } from 'react';

import { ClassNamesFromIStyles } from '../../utils/models';

// TODO: put this component into ui-kit

export interface IPanelFooterStyles {
  root: IStyle;
  container: IStyle;
}

export const EditablePanelFooterStyles = (theme: IH2OTheme): IPanelFooterStyles => {
  return {
    root: {
      position: 'absolute',
      bottom: '0',
      padding: '1.5rem',
      left: '0',
      width: '100%',
      backgroundColor: theme.semanticColors?.contentBackground,
      borderTop: `solid 1px ${theme.semanticColors?.inputBorder}`,
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  };
};

export interface IEditablePanelFooterProps {
  onCancel: () => any;
  onSave: () => any;
  closeButtonText: string;
  saveButtonText?: string;
  saveButtonDisabled: boolean;
  middleElement?: ReactNode;
  cancelBtnProps?: Partial<IButtonProps>;
  saveBtnProps?: Partial<IButtonProps>;
}

export function EditablePanelFooter({
  onCancel,
  onSave,
  closeButtonText = 'Close',
  saveButtonText = 'Save',
  saveButtonDisabled = false,
  middleElement,
  cancelBtnProps,
  saveBtnProps,
}: IEditablePanelFooterProps) {
  const theme = useTheme();
  const footerClassnames = useClassNames<IPanelFooterStyles, ClassNamesFromIStyles<IPanelFooterStyles>>(
    'PanelFooter',
    EditablePanelFooterStyles(theme)
  );
  return (
    <div className={footerClassnames.root}>
      <div className={footerClassnames.container}>
        <Button text={closeButtonText} onClick={onCancel} {...cancelBtnProps} />
        {middleElement}
        <Button
          disabled={saveButtonDisabled}
          styles={buttonStylesPrimary}
          text={saveButtonText}
          onClick={onSave}
          {...saveBtnProps}
        />
      </div>
    </div>
  );
}
